module.exports = __webpack_public_path__ + "img/mountain_lg.f6c75ff9.png";